// Libs
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

// Component
import AssetsPanel from '../components/AssetsPanel'

// Selectors & Action Creators
import {
  fitMapBounds,
} from 'fc-redux-leaflet'

import {
  updateFarm,
  updateField,
} from 'hfty-assets'

import {
  areaPerAsset$,
} from 'fc-assets'

import {
  // Selectors
  selectedFieldId$,
  selectedFarmId$,
  selectedSeasonId$,
  fieldsOfSelectedFarmAndSeason$,
  featuresOfSelectedField$,
  selectedFeatureIndex$,
  hoverFeatureIndex$,
  featureOperation$,
  panelToggled$,

  // Action Creators
  selectFeature,
  toggleHoverFeature,
  togglePanel,
  editSelectedField,
  deleteSelectedField,
  centerMapToFarm,
  centerMapToField,

  // Operators
  featureOperator,
} from 'hfty-map'

import {
  isEditing$,
  submitChangesToSpatial,
  isActiveToolsOp$,
} from 'fc-spatial'

import fieldSelectorOptions$ from '../selectors/fieldSelectorOptions'
import farmSelectorOptions$ from '../selectors/farmSelectorOptions'
import { seasonSelectorOptions$, updateCurrentSeason } from 'hfty-seasons'
import { jobsOfSelectedField$ } from 'hfty-soil-jobs'

// field borders
import assets$ from 'hfty-assets-dom/src/selectors/assets'
import fieldBorderOperations$ from 'hfty-assets-dom/src/selectors/uploadOperations'
import fieldBordersOperator from 'fc-operator-fieldborder'
import { uploadFieldBorders, updateFieldBorderOperation } from 'fc-upload-borders'

// Local
const mapStateToProps = (state: Object, props: Object) => {
  const selectedFarmId = selectedFarmId$(state)
  const selectedFieldId = selectedFieldId$(state)
  const areaPerAsset = areaPerAsset$(state)
  const area = areaPerAsset[selectedFieldId || selectedFarmId] || null

  return {
    panelToggled: panelToggled$(state),
    isEditing: isEditing$(state),
    isActiveToolsOp: isActiveToolsOp$(state),
    fields: fieldsOfSelectedFarmAndSeason$(state),
    farmSelectorOptions: farmSelectorOptions$(state),
    fieldSelectorOptions: fieldSelectorOptions$(state),
    seasonSelectorOptions: seasonSelectorOptions$(state),
    selectedSeasonId: selectedSeasonId$(state),
    selectedFarmId: selectedFarmId$(state),
    selectedFieldId: selectedFieldId$(state),
    featuresOfSelectedField: featuresOfSelectedField$(state),
    selectedFeatureIndex: selectedFeatureIndex$(state),
    hoverFeatureIndex: hoverFeatureIndex$(state),
    featureOperation: featureOperation$(state),
    uploadOperations: fieldBorderOperations$(state),
    assets: assets$(state),
    jobsOfSelectedField: jobsOfSelectedField$(state),
    area,
  }
}

function mapDispatchToProps (dispatch) {
  return {
    actions: bindActionCreators({
      fitMapBounds,
      togglePanel,
      onChangeSeason: updateCurrentSeason,
      onChangeFarm: updateFarm,
      onChangeField: updateField,
      onSelectFeature: selectFeature,
      onToggleHoverFeature: toggleHoverFeature,
      onAddFeature: featureOperator.actionCreators.add,
      onEditSelectedField: editSelectedField,
      onDeleteSelectedField: deleteSelectedField,
      onSubmitEditSelectedField: featureOperator.actionCreators.submitOperation,
      onCancelEditSelectedField: featureOperator.actionCreators.cancelOperation,
      onChangeEditSelectedField: featureOperator.actionCreators.updateOperation,
      onUpload: uploadFieldBorders,
      updateFieldBorderOperation: updateFieldBorderOperation,
      onCancelUploadOperations: fieldBordersOperator.actionCreators.cancelOperations,
      onSubmitUploadOperations: fieldBordersOperator.actionCreators.submitOperations,
      submitChangesToSpatial,
      centerMapToFarm,
      centerMapToField,
    }, dispatch),
  }
}

// Exports
export default connect(mapStateToProps, mapDispatchToProps)(AssetsPanel)
